import React from 'react';
import cn from 'classnames';

const Button = ({
  inverted = false,
  isActive = false,
  href,
  children,
  dataRoute,
  ...props
}) => {
  const Component = href ? 'a' : 'button'; // Conditional rendering of `a` or `button`

  return (
    <Component
      {...props}
      href={href}
      data-route={dataRoute === false ? undefined : ''}
      className={cn('as-Button', props.className, {
        'as-Button--inverted': inverted,
        'is-active': isActive,
      })}
    >
      {children}
    </Component>
  );
};

export default Button;
